import type { IndicatorTone } from './vacationBalanceCards.types';

export const INDICATOR_TONE_CLASSES: Record<IndicatorTone, string> = {
    neutral: 'bg-gray-50',
    danger: 'bg-red-50 border border-red-200',
    primary: 'bg-primary-50',
    warning: 'bg-amber-50',
    success: 'bg-emerald-50',
};

export const INDICATOR_VALUE_CLASSES: Record<IndicatorTone, string> = {
    neutral: 'text-raro-gray-900',
    danger: 'text-red-700',
    primary: 'text-primary-700',
    warning: 'text-amber-700',
    success: 'text-emerald-700',
};

export const BALANCE_CARD_LABELS = {
    balance: 'Saldo disponível',
    expired: 'Dias vencidos',
    nextDeadline: 'Limite p/ agendar até',
    entitledFrom: 'Direito a partir de',
    status: 'Situação',
    scheduled: 'Dias agendados',
} as const;

export const DEADLINE_IDLE_VALUES = {
    upToDate: 'Férias em dia',
    allScheduled: 'Férias agendadas',
} as const;
